/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest
 */
export interface FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest {
    /**
     * 
     * @type {number}
     * @memberof FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest
     */
    AccountId: number;
}

/**
 * Check if a given object implements the FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest interface.
 */
export function instanceOfFxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest(value: object): value is FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest {
    if (!('AccountId' in value) || value['AccountId'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequestFromJSON(json: any): FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest {
    return FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'AccountId': json['AccountId'],
    };
}

export function FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequestToJSON(json: any): FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest {
    return FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequestToJSONTyped(value?: FxIdWebFeaturesDocumentsGetAcceptedDocumentsGetAcceptedDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AccountId': value['AccountId'],
    };
}

